import React from 'react';
import poweredByBlackAndWhite from '../../ASUPhotos/logos/poweredByBlackAndWhite.png';

function PoweredByASUBlackAndWhite({ tenant }) {
  return tenant.name !== 'ASU' ? (
    <div
      style={{
        opacity: '.3',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <img
        alt="Powered By Arizona State University"
        style={{ width: '200px' }}
        src={poweredByBlackAndWhite}
      />
    </div>
  ) : null;
}

export default PoweredByASUBlackAndWhite;
